import { Box } from "@mui/material"


const MarkField = ({ onClick, data, lessonIndex, studentIndex }) => <Box
    onClick={(event) => onClick(event, data, lessonIndex, studentIndex)}
    sx={{
        width: 15,
        height: 33,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer",
        transition: "background 0.3s, opacity 0.3s",
        "&:hover": {
            background: "#CCCCCCAA",
            transition: "background 0.3s, opacity 0.3s"
        }
    }}
>
    {data.value ?? "·"}
</Box>

export default MarkField